import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { ATTACHMENT_API } from "./apiRoutes";

interface UseGetPresignedUrlProps {
  fileUploadId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPresignedUrl = async (fileUploadId: string) =>
  await axiosAuth.get(`${ATTACHMENT_API}/${fileUploadId}/presigned-url`);

const useGetPresignedUrl = ({
  queryParams,
  fileUploadId
}: UseGetPresignedUrlProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["attachment", fileUploadId],
    queryFn: () => getPresignedUrl(fileUploadId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPresignedUrl;
